@import '@alfalab/core-components-vars/src/index.css';
@import '../vars.css';
